{
  "add": "Agregar una cosa",
  "add_photo": "Agregar foto",
  "capture_hint": "Un enlace, unas palabras o ambos. Puedes arreglarlo después.",
  "capture_no_list": "No ponerlo en {name}",
  "capture_on_list": "En {name}",
  "capture_placeholder": "Pega un enlace, una foto o escribe unas palabras sobre lo que quieres",
  "capture_title": "Agregar una cosa",
  "count": {
    "one": "{count} cosa",
    "other": "{count} cosas"
  },
  "details_hint": "Nombre, precio y foto",
  "details_switch": "Obtener detalles de la página",
  "edit_failed": "El cambio no se guardó. ¿Intentar de nuevo?",
  "edit_thing": "Editar {name}",
  "edit_title": "Editar cosa",
  "empty_body": "Toca + en cuanto veas algo que quieras. Un enlace, unas palabras, lo que tengas.",
  "empty_heading": "Todavía no hay nada",
  "field_brand": "Marca",
  "field_lists": "Listas",
  "field_location": "Dónde lo viste",
  "field_note": "Nota",
  "field_price": "Precio",
  "field_store": "Tienda",
  "field_title": "Nombre",
  "field_url": "Enlace",
  "first_run_line": "Comparte desde cualquier app, pega un enlace o toma una foto: todo llega aquí.",
  "first_run_line_web": "Pega un enlace o toma una foto: todo llega aquí.",
  "getting_details": "Obteniendo detalles…",
  "gifted_badge": "Alguien te lo va a regalar",
  "gifted_note": "Alguien te lo va a regalar, así que no hace falta que lo compres tú.",
  "got_cheer": "¡Salud por eso!",
  "got_section": "Ya lo tengo",
  "heading": "Mis cosas",
  "i_got_it": "Ya lo tengo",
  "limit_list_full": "Esa lista tiene {max} cosas, lo máximo que cabe en una lista por ahora.",
  "limit_lists": "{max} listas es el máximo por ahora. Elimina una para crear otra.",
  "limit_things": "Tienes {max} cosas, el máximo por ahora. Quita algunas que ya tengas o que ya no quieras, y luego agrega más.",
  "limit_viewers": "{max} personas es el máximo en una lista por ahora.",
  "list_all": "Todo",
  "list_becoming_private": "Sus cosas dejarán de compartirse.",
  "list_becoming_private_kept": "Sus cosas dejarán de compartirse. Las personas que están en ella se quedan, y volverán a verlas si la vuelves a compartir.",
  "list_becoming_sharing": "Todo lo que hay en esta lista será visible para las personas con quienes la compartas.",
  "list_becoming_sharing_parked": "Todo lo que hay en esta lista será visible para las personas con quienes la compartas, y sus cosas volverán a aparecer en Todo.",
  "list_create": "Crear lista",
  "list_date": "¿Cuándo es?",
  "list_date_clear": "Borrar",
  "list_date_hint": "Algo que esperar con ilusión. Déjalo vacío si no hay fecha.",
  "list_delete_failed": "No se pudo eliminar esa lista. ¿Intentar de nuevo?",
  "list_edit_title": "Editar lista",
  "list_empty_body": "Agrega cosas a esta lista desde cada cosa, o toca + mientras estás aquí.",
  "list_empty_heading": "Aún no hay nada en {name}",
  "list_file_failed": "La lista no cambió. ¿Intentar de nuevo?",
  "list_keep_out_hint": "Sus cosas solo aparecen al abrir esta lista. Un lugar para guardarlas.",
  "list_keep_out_switch": "Fuera de Todo",
  "list_link_after_save": "Cuando la guardes, también podrás crear un enlace para la familia que no tiene la app.",
  "list_link_copied": "Copiado",
  "list_link_copy": "Copiar",
  "list_link_failed": "No se pudo cambiar el enlace. ¿Lo intentas de nuevo?",
  "list_link_keep": "Dejarlo activo",
  "list_link_label": "El enlace de la lista",
  "list_link_off": "Desactivado. Solo las personas de arriba ven esta lista.",
  "list_link_off_explain": "¿Desactivar el enlace? Deja de funcionar para todos los que lo tienen, y lo que iban a regalar desde él y no habían comprado queda libre.",
  "list_link_offline": "No tienes conexión. Inténtalo de nuevo cuando estés en línea.",
  "list_link_on": "Pueden verla y regalar, sin crear una cuenta.",
  "list_link_preview": "Verla como tu familia",
  "list_link_send": "Enviar…",
  "list_link_share_text": "Esta es mi lista {list} en TingThings. Di qué vas a regalar, para que nadie repita, sin necesidad de la app.",
  "list_link_switch": "Cualquiera con el enlace",
  "list_link_turn_off": "Desactivar",
  "list_link_warning": "Quien lo tenga ve lo que ya está apartado, también las sorpresas. Para verla tú, usa Verla como tu familia.",
  "list_name": "Nombre",
  "list_new": "Nueva lista",
  "list_new_title": "Nueva lista",
  "list_offer_body": "Cualquiera con el enlace puede ver esta lista y regalar algo de ella, sin la app y sin crear una cuenta.",
  "list_offer_done": "Listo",
  "list_offer_here": "Este es el enlace",
  "list_offer_make": "Crear un enlace",
  "list_offer_not_now": "Ahora no",
  "list_offer_question": "¿Enviar un enlace a la familia que no tiene la app?",
  "list_offer_shared": "{list} es una lista para compartir",
  "list_offer_warning": "Quien lo tenga ve lo que ya está apartado, también las sorpresas.",
  "list_remove": "Eliminar lista",
  "list_remove_confirm": "Toca otra vez. Sus cosas se quedan.",
  "list_save_failed": "Esa lista no se guardó. ¿Intentar de nuevo?",
  "list_sharing": "Lista para compartir",
  "list_sharing_off": "Privada. Solo tú la ves.",
  "list_sharing_on": "Solo las personas que agregues ven lo que tiene.",
  "list_sharing_switch": "Lista para compartir",
  "list_viewer_add_failed": "No se pudo agregar a esa lista. ¿Intentar de nuevo?",
  "list_viewer_remove_failed": "No se pudo quitar de esa lista. ¿Intentar de nuevo?",
  "list_viewers_add": "Agregar personas",
  "list_viewers_add_name": "Agregar a {name}",
  "list_viewers_add_one": "Agregar",
  "list_viewers_all_added": "Todas las personas que te siguen ya están en esta lista.",
  "list_viewers_everyone": "Todos en esta lista ven quién más está en ella.",
  "list_viewers_heading": "Quién la ve",
  "list_viewers_kept": {
    "one": "{count} persona sigue en esta lista, y la verá de nuevo si la vuelves a compartir.",
    "other": "{count} personas siguen en esta lista, y la verán de nuevo si la vuelves a compartir."
  },
  "list_viewers_no_followers": "Solo puedes agregar a personas que te siguen. Invita a alguien, o comparte tu usuario, @{handle}, para que te sigan.",
  "list_viewers_none": "Nadie todavía. Agrega a personas que te siguen.",
  "list_viewers_on_create": "Se agregan a la lista cuando la creas.",
  "list_viewers_on_save": "Quién ve esto cambia cuando guardas.",
  "list_viewers_take_off": "Quitar",
  "list_viewers_take_off_name": "Quitar a {name} de esta lista",
  "lists_label": "Listas",
  "load_failed": "No se pudieron cargar tus cosas.",
  "location_denied": "TingThings no tiene permiso para ver tu ubicación, así que se guardará sin ella. Puedes permitirlo en Configuración.",
  "location_finding": "Buscando dónde estás…",
  "location_found": "Listo. Solo tú lo verás.",
  "location_hint": "Guarda dónde lo viste, para encontrarlo otra vez. Solo tú lo ves.",
  "location_saved": "Ubicación guardada",
  "location_switch": "Recordar dónde estoy",
  "location_unavailable": "Este dispositivo no puede compartir su ubicación, así que se guardará sin ella.",
  "more_details": "Más detalles",
  "no_details": "Sin detalles de esta página",
  "note_placeholder": "Talla, color, lo que ayude",
  "open_in_maps": "Abrir en Mapas",
  "open_link": "Abrir",
  "open_thing": "Abrir {name}",
  "outbox_dropped": "Algo que guardaste sin conexión no se pudo agregar. ¿Lo capturas de nuevo?",
  "page_description": "Todo lo que quieres, en un solo lugar.",
  "page_title": "Mis cosas — TingThings",
  "parked_more": {
    "one": "{count} más en {name}",
    "other": "{count} más en {name}"
  },
  "parked_still_shared": "Sigue en {names}. Las personas con quienes la compartes pueden verla.",
  "parked_take_off": "Quitarla de ahí",
  "photo_failed": "Se guardó, pero la foto no se subió. Agrégala de nuevo desde la cosa.",
  "photo_paste_hint": "¿Copiaste una foto? Pégala en el nombre o la nota.",
  "photo_preparing": "…",
  "photo_unreadable": "No se pudo leer esa foto.",
  "price_about": "aprox. {price}",
  "price_invalid": "Eso no parece un precio.",
  "price_placeholder": "¿Más o menos cuánto?",
  "recently_added": "Agregado recientemente",
  "remove": "Quitar",
  "remove_confirm": "Toca otra vez para quitar",
  "remove_failed": "No se pudo quitar. ¿Intentar de nuevo?",
  "remove_location": "Quitar",
  "remove_photo": "Quitar foto",
  "replace_photo": "Cambiar foto",
  "retake_photo": "Tomar otra",
  "save": "Guardar",
  "save_failed": "No se guardó. ¿Intentar de nuevo?",
  "saving": "Guardando…",
  "still_want_it": "Aún lo quiero",
  "store_placeholder": "Dónde lo venden",
  "take_photo": "Tomar una foto",
  "untitled": "Sin título",
  "url_invalid": "Eso no parece un enlace.",
  "waiting_to_send": "Pendiente de enviar"
}
